var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsPrimaryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2632_33988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.911 8.25118L12.8073 10.3331H14.5555C14.6436 10.3297 14.7306 10.3537 14.8046 10.4017C14.8786 10.4497 14.936 10.5194 14.9689 10.6012C15.0019 10.6831 15.0088 10.7731 14.9888 10.859C14.9687 10.9449 14.9226 11.0226 14.8568 11.0813L13.3416 12.4314L14.1808 14.364C14.2182 14.4525 14.2268 14.5505 14.2054 14.6442C14.184 14.7379 14.1337 14.8224 14.0617 14.8859C13.9896 14.9493 13.8994 14.9885 13.8039 14.9978C13.7083 15.0072 13.6123 14.9862 13.5293 14.9379L11.5013 13.7943L9.47107 14.9379C9.3882 14.9857 9.29246 15.0064 9.19724 14.997C9.10202 14.9875 9.01216 14.9484 8.94031 14.8852C8.86846 14.822 8.81822 14.7378 8.79666 14.6445C8.7751 14.5512 8.78332 14.4536 8.82015 14.3652L9.65929 12.4326L8.14417 11.0825C8.07814 11.0239 8.03175 10.9464 8.01148 10.8605C7.9912 10.7746 7.9979 10.6845 8.03076 10.6025C8.06363 10.5206 8.12103 10.4509 8.19504 10.4028C8.26911 10.3548 8.35611 10.3308 8.44428 10.3343H10.189L11.0876 8.25234C11.1263 8.17647 11.1853 8.11279 11.2578 8.06823C11.3304 8.02374 11.4138 8.00012 11.499 8C11.5841 7.99988 11.6676 8.02327 11.7403 8.06759C11.813 8.11191 11.8721 8.17542 11.911 8.25118Z",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 4H13",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4 11H2.2C1.88174 11 1.57652 10.8683 1.35147 10.6339C1.12643 10.3994 1 10.0815 1 9.75V2.25C1 1.91848 1.12643 1.60054 1.35147 1.36612C1.57652 1.1317 1.88174 1 2.2 1H11.8C12.1182 1 12.4235 1.1317 12.6485 1.36612C12.8736 1.60054 13 1.91848 13 2.25V7.875",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6H8",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8H5",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2632_33988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsPrimaryIcon);
export default __webpack_public_path__ + "static/media/AsPrimaryIcon.fee63e9f82555800e81a3f997905edf5.svg";
export { ForwardRef as ReactComponent };